// @ts-nocheck
/* eslint-disable */
export const youAvatarIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><rect width="24" height="24" fill="#10A37F" rx="12"/><path fill="#fff" d="M11.57 16v-2.9L9.06 8.9h1.02L12 12.22l1.92-3.32h1.02l-2.51 4.2V16z"/></svg>`,
    name: 'you-avatar' as const
};